export const endpoints = (baseUrl: string) => ({
	baseUrl,
	healthCheck: `${baseUrl}/`,
	apiVersion: `${baseUrl}/version`,
	graphQlEndpoint: `${baseUrl}/graphql`,
});
